import Tabs from 'infrastructure/js/components/Tabs/tabs';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import useTabsWithUrl from 'infrastructure/js/hooks/useTabsWithUrl';
import ActiveCassettesContainer from '../../../containers/ActiveCassettesPage/activeCassettesContainer';
import AlertedCassettesContainer from '../../../containers/AlertedCassettesPage/alertedCassettesContainer.js';
import ArchivedCassettesContainer from '../../../containers/ArchivedCassettesPage/archivedCassettesContainer';

import './cassettesPage.scss';


const tabsLabels = createLabelHelper('mat.common.tabs.');

const { Tab } = Tabs;

const tabKeys = {
  ACTIVE: 'active',
  ALERTED: 'alerted',
  ARCHIVED: 'archived',
};

const CassettesPage = () => {
  const { getTabKeyFromURL, setTabKeyInURL } = useTabsWithUrl(
    'PredefinedViews/rawMaterials/cassettes',
    Object.values(tabKeys),
    'active',
    'materialStatus'
  );

  const handleTabClick = (tabKey) => {
    setTabKeyInURL(tabKey);
  };

  return (
    <div className="cassettes-page">
      <Tabs id="cassettes-tabs" tabType="content" activeKey={getTabKeyFromURL()} onSelect={handleTabClick} mountOnlyActiveTab={true}>
        <Tab title={tabsLabels.get('active')} eventKey={tabKeys.ACTIVE}>
          <ActiveCassettesContainer />
        </Tab>
        <Tab title={tabsLabels.get('alerted')} eventKey={tabKeys.ALERTED}>
          <AlertedCassettesContainer />
        </Tab>
        <Tab title={tabsLabels.get('archived')} eventKey={tabKeys.ARCHIVED}>
          <ArchivedCassettesContainer />
        </Tab>
      </Tabs>
    </div>
  );
};

export default CassettesPage;
